<header class="masthead">
  <div class="inner">
    <div class="masthead-logo">
      <img src="../../../assets/images/logo-blk-001.svg" width="40" alt="Masthead Logo" />
      <div class="corner"></div>
    </div>
    <h1>{{ title }}</h1>
    <p class="subtitle" [innerHTML]="subtitle"></p>
  </div>
</header>
